<div class="app-modal-bg d-flex justify-content-center align-items-center">
  <div
    class="col-xl-6 col-md-6 col-sm-10 col-xs-12 d-flex justify-content-center align-items-center"
  >
    <div class="card shadow-lg">
      <div class="card-header font-weight-bold">{{ content["title"] }}</div>
      <div class="card-body">
        <div class="card-text" [innerHTML]="content['body']"></div>
        <form
          class="app-content-checks"
          (ngSubmit)="onSubmit()"
          #consentForm="ngForm"
        >
          <hr />
          <div class="form-check">
            <input
              type="checkbox"
              class="form-check-input"
              id="consent-agree"
              name="consent-agree"
              required
              ngModel
            /><label for="consent-agree" class="form-check-label">{{
              content["agree"]
            }}</label>
          </div>
          <div *ngIf="content['NDA']" class="form-check mt-2">
            <input
              type="checkbox"
              class="form-check-input"
              id="consent-nda"
              name="consent-nda"
              required
              ngModel
            /><label for="consent-nda" class="form-check-label">{{
              content["NDA"]
            }}</label>
          </div>
          <button
            class="btn btn-outline-dark mt-4 w-100"
            type="submit"
            [disabled]="!consentForm.valid"
          >
            {{ continueButtonLabel }}
          </button>
        </form>
      </div>
    </div>
  </div>
</div>
